import React, { useState } from "react";
import HotelImage from "./components/HotelImage";
import HotelOverview from "./components/HotelOverview";
import AvailableRoom from "./components/AvailableRoom";
import Testimonial from "./components/Testimonial";
import Faq from "./components/Faq";
// import HotelCard from "./components/HotelCard";
import NftCard from "../../components/card/NftCard";
import NFt3 from "assets/img/nfts/Nft3.png";
import LocationMap from "./components/LocationMap";

const HotelDetail = () => {
  const [visibleCount, setVisibleCount] = useState(() => {
    if (window.innerWidth < 768) return 3; // sm and below
    if (window.innerWidth > 1600) return 8; // md and above (2 rows if 3 per row)
    return 6; // md and above (2 rows if 3 per row)
  });

  const tickets = new Array(12).fill({
    title: "Hotel Title",
    assigned_to: "Unknown User",
    status: "Status",
    image: NFt3,
    created_at: "Date Not Available",
  });

  return (
    <div className="mt-24 px-4 pt-1">
      <HotelImage />
      <HotelOverview />

      {/* Available Rooms Section */}
      <div className="mx-auto mt-10 max-w-screen-2xl rounded-xl bg-white p-6 shadow">
        <AvailableRoom />
        <AvailableRoom />
        <AvailableRoom />
      </div>
      <LocationMap />
      <Testimonial />
      <Faq />

      {/* Related Hotels Section */}
      <div className="mx-auto my-10 max-w-screen-2xl rounded-xl bg-gray-100 p-3 shadow md:p-6">
        <h2 className="mb-6 text-2xl font-bold">Related Hotels</h2>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-4">
          {tickets.slice(0, visibleCount).map((ticket, idx) => (
            <NftCard
              key={idx}
              title={ticket.title}
              assigned_to={ticket.assigned_to}
              status={ticket.status}
              image={ticket.image}
              created_at={ticket.created_at}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default HotelDetail;
